<template>
  <div class="my-4 text-center">
    <img src="#" alt="404" />
    dsdss
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
